<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableGatewayResourceListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableGatewayResourceVue = {};
export default {
  name: "TableGatewayResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountNameSearchIDVal: "",
      columns: [
        {
          title: this.$t("RAM.AWS.Gateway.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.Gateway.gatewayName"),
          key: "name"
        },
        {
          title: this.$t("RAM.AWS.Gateway.gatewayID"),
          key: "gatewayId"
        },
        {
          title: "VPC ID",
          key: "vpcId"
        }
      ],
      tableGatewayResourceListData: [],
      accountNameSearchIDVal: ""
    };
  },
  beforeCreate: function() {
    tableGatewayResourceVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountNameSearchID", function(accountNameSearchIDVal) {
      tableGatewayResourceVue.accountNameSearchIDVal = accountNameSearchIDVal;
    });
    eventBus.$on("companyId", function(val) {
      tableGatewayResourceVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableGatewayResourceVue.getGatewayResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getGatewayResourceListData: function() {
      this.$api.resourceManagement
        .selectAWSGatewayByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: this.companyId,
          accountName: this.accountNameSearchIDVal
        })
        .then(res => {
          this.tableGatewayResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableGatewayResourceVue.getGatewayResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableGatewayResourceVue.getGatewayResourceListData();
    },
    // 销毁caseSearchID
    beforeDestroy: function() {
      eventBus.$off("accountNameSearchID");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/gateway/TableGatewayResource.vue